<!-- <div class="wrapper app-cover">
  <div class="main-panel">
    <div class="content pt-4 pt-lg-5"></div>
  </div>
</div> -->
<!-- <app-guest-navbar></app-guest-navbar> -->
<div class="">
  <router-outlet></router-outlet>
</div>
